import Vue from 'vue'
import Router from 'vue-router'
// import syb from '../views/syb.vue'

Vue.use(Router)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/syb.vue'),
  },
  // 渠道加盟
  {
    path: '/channel',
    name: 'Channel',
    component: () => import('../views/more/channel.vue'),
  },
  // 电商流量推广
  {
    path: '/promote',
    name: 'XmDetail',
    component: () => import('../views/more/promote.vue'),
  },
  // 关于我们
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/more/aboutUs.vue'),
  },
  // 跨境电商托管
  {
    path: '/cbeCommerce',
    name: 'CeCommerce',
    component: () => import('../views/more/cbeCommerce.vue'),
  },
  // 电商教育
  {
    path: '/education',
    name: 'Education',
    component: () => import('../views/more/education.vue'),
  },
  // 亚马逊
  {
    path: '/alMax',
    name: 'XmDetail',
    component: () => import('../views/more/alMax.vue'),
  },

  // 淘宝详情
  {
    path: '/tbReplace',
    name: 'TbReplace',
    component: () => import('../views/more/tbReplace.vue'),
  },
  // 拼多多详情
  {
    path: '/pddReplace',
    name: 'TbReplace',
    component: () => import('../views/more/pddReplace.vue'),
  },
  // 京东详情
  {
    path: '/jdReplace',
    name: 'TbReplace',
    component: () => import('../views/more/jdReplace.vue'),
  },
  // 引力魔方
  {
    path: '/ylReplace',
    name: 'TbReplace',
    component: () => import('../views/more/ylReplace.vue'),
  },
  // 小麦详情
  {
    path: '/xmDetail',
    name: 'XmDetail',
    component: () => import('../views/more/xmDetail.vue'),
  },
  // 省油快车
  {
    path: '/syFast',
    name: 'XmDetail',
    component: () => import('../views/more/syFast.vue'),
  },
  // 购买页
  {
    path: '/buy',
    name: 'Buy',
    component: () => import('../views/more/buy.vue'),
  },
  // 全店代运营
  {
    path: '/wholeShop',
    name: 'WholeShop',
    component: () => import('../views/more/wholeShop.vue'),
  },
  // 超级魔方
  {
    path: '/superMF',
    name: 'XmDetail',
    component: () => import('../views/more/superMF.vue'),
  },
  // 聚麦报表
  {
    path: '/jmReport',
    name: 'JmReport',
    component: () => import('../views/more/jmReport.vue'),
  },
  // 省油智投
  {
    path: '/syRoBo',
    name: 'XmDetail',
    component: () => import('../views/more/syRoBo.vue'),
  },
   // 设计服务
   {
    path: '/designServe',
    name: 'DesignServe',
    component: () => import('../views/more/designServe.vue'),
  },
  // 公司pdf
  {
    path: '/detailsDown',
    name: 'detailsDown',
    component: () => import('../views/more/detailsDown.vue'),
  },
]

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

// 解决重复路由点击报错
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

export default router
